import { ScreenshotBoundingBox } from '@evinced-private/ui-common';

type ProblemInfo = {
	coords: ScreenshotBoundingBox;
	rootBounds: ScreenshotBoundingBox;
	screenshotUrl: string;
};

const DEFAULT_MIN_VALUE = 5;

// TODO: Replace with EvScreenshotService once this functionality is added to the service
export const drawMobileCroppedIssue = async ({
	coords,
	rootBounds,
	screenshotUrl
}: ProblemInfo): Promise<string> => {
	if (!screenshotUrl) {
		return '';
	}

	const img = new Image();
	img.crossOrigin = 'anonymous';
	img.src = screenshotUrl;

	await new Promise<void>((resolve, reject) => {
		img.onload = () => resolve();
		img.onerror = () => reject(new Error('Failed to load image'));
	});

	const canvas = document.createElement('canvas');
	const ctx = canvas.getContext('2d');

	if (!ctx) {
		return '';
	}

	// Calculate scaling factors and scaled coordinates
	const scaleX = img.width / rootBounds.width;
	const scaleY = img.height / rootBounds.height;
	const scaledCoords = {
		x: coords.x * scaleX,
		y: coords.y * scaleY,
		width: coords.width * scaleX,
		height: coords.height * scaleY
	};

	// Calculate crop area - exact issue bounds
	const cropX = Math.max(0, scaledCoords.x);
	const cropY = Math.max(0, scaledCoords.y);
	const cropWidth = Math.min(img.width - cropX, scaledCoords.width) || DEFAULT_MIN_VALUE;
	const cropHeight = Math.min(img.height - cropY, scaledCoords.height) || DEFAULT_MIN_VALUE;

	// Set canvas size and draw cropped image
	canvas.width = cropWidth;
	canvas.height = cropHeight;
	ctx.drawImage(img, cropX, cropY, cropWidth, cropHeight, 0, 0, cropWidth, cropHeight);

	return canvas.toDataURL();
};
